import { render } from "./M19CommentMaterialsModal.vue?vue&type=template&id=130c46d4&scoped=true"
import script from "./M19CommentMaterialsModal.vue?vue&type=script&lang=js"
export * from "./M19CommentMaterialsModal.vue?vue&type=script&lang=js"

import "./M19CommentMaterialsModal.vue?vue&type=style&index=0&id=130c46d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130c46d4"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QMarkupTable});
